import { api, qs } from '../client'
import type { Notification, NotificationFilter, Page, UnreadCount } from '../types'

export const notificationsApi = {
  list: (filter: NotificationFilter = 'all', cursor?: string, limit = 20) =>
    api.get<Page<Notification>>(
      `/notifications${qs({ type: filter === 'all' ? undefined : filter, cursor, limit })}`,
    ),

  unreadCount: () => api.get<UnreadCount>('/notifications/unread-count'),

  /** 不传 up_to_id 就是全部已读 */
  markRead: (upToId?: string) =>
    api.post<UnreadCount & { marked: number }>('/notifications/read', { up_to_id: upToId ?? null }),
}
